import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap/dist/css/bootstrap.css';
import moment from 'moment';
import React from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { FormGroup } from 'reactstrap';
import './_datefilter.scss';

const DateFilter = ({ label, setDateRange }) => {
  const handleApply = (e, picker) => {
    e.preventDefault();

    setDateRange({
      startDate: picker.startDate.format('YYYY/MM/DD'),
      endDate: picker.endDate.format('YYYY/MM/DD'),
    });

    picker.element.val(
      `${picker.startDate.format('DD MMM YYYY')} - ${picker.endDate.format('DD MMM YYYY')}`,
    );
  };
  const handleCancel = (e, picker) => {
    e.preventDefault();

    picker.element.val('');
  };

  return (
    <FormGroup className="gbnl-input date-filter">
      <label>
        <span>{label}</span>
        <DateRangePicker
          initialSettings={{
            autoUpdateInput: false,
            locale: {
              cancelLabel: 'Clear',
            },
            ranges: {
              Today: [moment().toDate(), moment().toDate()],
              Yesterday: [
                moment().subtract(1, 'days').toDate(),
                moment().subtract(1, 'days').toDate(),
              ],
              'Last 7 Days': [
                moment().subtract(6, 'days').toDate(),
                moment().toDate(),
              ],
              'Last 30 Days': [
                moment().subtract(29, 'days').toDate(),
                moment().toDate(),
              ],
              'This Month': [
                moment().startOf('month').toDate(),
                moment().endOf('month').toDate(),
              ],
              'Last Month': [
                moment().subtract(1, 'month').startOf('month').toDate(),
                moment().subtract(1, 'month').endOf('month').toDate(),
              ],
            },
          }}
          onApply={handleApply}
          onCancel={handleCancel}
        >
          <input type="text" className="form-control" />
        </DateRangePicker>
      </label>
    </FormGroup>
  );
};

DateFilter.defaultProps = {};

DateFilter.propTypes = {};

export default DateFilter;
